import { useEffect, useRef, useState } from 'react';
import { SliderInput, SliderWrap, PitchWrap } from 'components/Slider/styles';

const getSliderlinearGrad = (val: number, active:boolean) => `linear-gradient(to right, ${active? 'var(--secondary)': 'var(--sliderFillColor)'} 0%, ${active? 'var(--secondary)': 'var(--sliderFillColor)'} ${val}%, var(--sliderTrackColor) ${val}%, var(--sliderTrackColor) 100%)`;
export default function PitchSlider(props: { 
	pitch: number, 
	onChange?: (value: string) => void , 
	active: boolean,
	disabled?: boolean
}) {
	const sliderRef = useRef<HTMLInputElement | null>(null);
	const [pitchval, setPitchVal]= useState<number>(props.pitch);

	useEffect(() => {
		setPitchVal(props.pitch);
	}, [props.pitch]);

	return (
		<SliderWrap className='pitch-slider edit-fecet-slider manual-pitch-wrap'>
			<PitchWrap className="pitch-label manual-pitch-label facet-pitch-detail">
				<label>Pitch:</label>
				<span className="pitch-degree">{Math.round(pitchval)}</span>
			</PitchWrap>
			<SliderInput
				type='range'
				className='facet-slider-range'
				min={0}
				max={80}
				defaultValue={props.pitch}
				value={pitchval}
				step={1}
				ref={sliderRef}
				disabled={props.disabled}
				style={{background: getSliderlinearGrad((pitchval / 80) * 100, props.active)}}
				onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
					const value = Math.ceil(+e.target.value);
					e.target.value = value.toString();
					setPitchVal(value);
					props.onChange?.(e.target.value);
				}}
			/>
		</SliderWrap>
	);
}
